import ScheduleContainer from "./Schedule.container";

export default ScheduleContainer;
